// Use link navigation: window.open can make Chrome/Edge exit fullscreen
// on the Customer Display window opened by this app.
export const openUrlInNewTab = url => {
  if (typeof url !== 'string' || !url.trim()) {
    throw new Error('Missing URL')
  }

  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)

  try {
    link.click()
  } finally {
    link.remove()
  }
}
